import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { ACCOUNTING, TranslationService } from '@nebula-shared/data-access';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-balance-summary',
  imports: [CommonModule],
  templateUrl: './balance-summary.component.html',
  styleUrl: './balance-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BalanceSummaryComponent {
  protected translation = inject(TranslationService);

  t(key: string): string {
    return this.translation.translate(key);
  }
  label = ACCOUNTING.COMMON.BALANCE_SUMMARY.LABEL;

  // Inputs
  totalDebito = input<number>(0);
  totalCredito = input<number>(0);

  readonly diferencia = computed(() => this.totalDebito() - this.totalCredito());
  readonly isBalanceado = computed(() => Math.abs(this.diferencia()) < 0.01);
}
